var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSobreLampada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_19",
    "data-name": "Ret\\xE2ngulo 19",
    width: 56.002,
    height: 76.418,
    fill: "#212121"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Button_SIZE_LARGE_STATE_DEFAULT_STYLE_STYLE2_",
    "data-name": "Circle Button [SIZE=LARGE][STATE=DEFAULT][STYLE=STYLE2]",
    transform: "translate(0.038 -0.313)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_SIZE:LARGE_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [SIZE:LARGE][STATE:DEFAULT][STYLE:STYLE2]",
    width: 113,
    height: 112,
    rx: 56,
    transform: "translate(-0.038 0.312)",
    fill: "#bbe56b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38",
    transform: "translate(28.577 18.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_106",
    "data-name": "Caminho 106",
    d: "M34.36,41.973l3.675,0a1.37,1.37,0,0,1,1.425,1.515v2.55a3.812,3.812,0,1,1-4.994,4.411,3.767,3.767,0,0,1,2.4-4.378L36.9,44.54l-3.851-.023a1.294,1.294,0,0,1-1.231-1.309l-.006-3.761-2.55.008,0,24.226,9.213-.01a3.86,3.86,0,0,1,3.387,1.894c.868,1.407.235,2.954-.254,4.171.757,1.31,1.484,2.821.673,4.447a3.968,3.968,0,0,1-3.659,2.234H17.417a3.883,3.883,0,0,1-3.734-2.289,3.974,3.974,0,0,1,.824-4.354,3.754,3.754,0,0,1,.676-5.358c-.215-3.261-3.194-7.44-5.071-10.15A56.467,56.467,0,0,1,6.9,49.3C3.131,42.456-.127,33.317,0,25.422.178,14.863,6.863,6.157,16.49,2.218A30.965,30.965,0,0,1,27.724,0a1.36,1.36,0,0,1,1.542,1.474v20.12l5.088.013.011-6.619a3.807,3.807,0,1,1,2.555,0l0,6.61,2.5.02a1.284,1.284,0,0,1,1.3,1.268l.032,2.537,3.8,0-.007-4.065a3.8,3.8,0,1,1,2.573,0L47.1,26.619a1.324,1.324,0,0,1-1.346,1.35l-5.014.013,0,5.078,7.845.006a3.875,3.875,0,0,1,4.231-2.487,3.8,3.8,0,1,1-4.192,5.039l-7.867-.006-.038,2.537a1.327,1.327,0,0,1-1.456,1.286H34.381ZM12.034,35.328c.187-.18-.089-.96-.315-1.014-1.142-.277-2.82-.284-2.823-1.582l-.01-4.268a1.326,1.326,0,0,1,1.084-1.37l1.755-.375c.281-.06.477-.877.276-1.064L10.766,24.5a1.369,1.369,0,0,1-.25-1.71,29.877,29.877,0,0,1,2.061-3.536,1.4,1.4,0,0,1,1.629-.65l1.732.549.7-.707-.519-1.589a1.444,1.444,0,0,1,.648-1.782,32.534,32.534,0,0,1,3.455-2.015c1.476-.744,1.869.529,2.99,1.512.2.18.953-.118,1.02-.4l.48-2.047a2.624,2.624,0,0,1,2.006-.644V2.594a26.513,26.513,0,0,0-15.971,6A22.437,22.437,0,0,0,2.628,28.012,53.144,53.144,0,0,0,9.257,48.291c1.913,3.414,4.73,6.724,6.661,10.312A17.984,17.984,0,0,1,17.7,63.675l9.016,0,0-14.108c-.682-.077-1.429-.045-1.812-.511-.648-.788-.382-2.168-.9-2.493-1.5-.938-1.558,2.553-3.881,1.36a33.664,33.664,0,0,1-3.357-1.974,1.421,1.421,0,0,1-.679-1.65l.55-1.73-.693-.69-1.885.581a1.4,1.4,0,0,1-1.471-.68,29.373,29.373,0,0,1-2.068-3.544,1.357,1.357,0,0,1,.177-1.622ZM35.517,10.169a1.249,1.249,0,1,0,.381,2.464,1.248,1.248,0,0,0-.381-2.464M13.345,32.04A1.408,1.408,0,0,1,14.2,33l.589,2.183a1.448,1.448,0,0,1-.384,1.5L13.145,37.8l1.1,1.926,1.628-.522a1.437,1.437,0,0,1,1.463.4l1.534,1.531a1.439,1.439,0,0,1,.47,1.374l-.546,1.736,1.872,1.122,1.252-1.332A1.43,1.43,0,0,1,23.25,43.7l2.289.615c.68.183.848.675,1.137,1.347l.008-3.773a11.452,11.452,0,0,1,0-22.753c.038-1.268.038-2.43-.011-3.775-.292.755-.506,1.191-1.259,1.392l-2.168.579a1.436,1.436,0,0,1-1.335-.324L20.688,15.66,18.783,16.8l.55,1.695a1.447,1.447,0,0,1-.469,1.4l-1.54,1.535a1.426,1.426,0,0,1-1.331.422l-1.747-.546-1.1,1.89,1.344,1.233a1.419,1.419,0,0,1,.333,1.271L14.2,28.032a1.365,1.365,0,0,1-.944.981l-1.835.413.031,2.209Zm32.336-15.5a1.249,1.249,0,1,0,1.379,1.039,1.243,1.243,0,0,0-1.379-1.039M26.715,21.751a8.872,8.872,0,0,0,0,17.567ZM38.187,36.868l-.012-12.719-8.91.012V36.883ZM52.045,33.1a1.25,1.25,0,1,0,.433,2.458,1.264,1.264,0,0,0,.949-1.435A1.247,1.247,0,0,0,52.045,33.1M37.729,48.463a1.241,1.241,0,0,0-.67,1.712,1.273,1.273,0,0,0,1.524.633,1.248,1.248,0,1,0-.854-2.345m.8,20.218a1.259,1.259,0,0,0,1.208-1.144c.06-.468-.26-1.292-.959-1.292l-21.643,0c-.693,0-.975.947-.876,1.367a1.31,1.31,0,0,0,1.165,1.065Zm.105,5.186a1.319,1.319,0,1,0,.147-2.632l-21.52,0a1.287,1.287,0,0,0-1.349,1.321,1.3,1.3,0,0,0,1.351,1.31Z",
    transform: "translate(0 0)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_107",
    "data-name": "Caminho 107",
    d: "M590.53,175.078l-2.42.861-.923-2.267,2.279-1.108Z",
    transform: "translate(-535.924 -157.499)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_108",
    "data-name": "Caminho 108",
    d: "M613.914,296.371l-2.546-.2.116-2.476,2.511-.019Z",
    transform: "translate(-557.994 -268.036)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_109",
    "data-name": "Caminho 109",
    d: "M513.406,570.571l-2.105-1.421,1.385-2.116,2.16,1.329Z",
    transform: "translate(-466.663 -517.531)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M420.81,19.571l-2.325-.877.769-2.411,2.526.933Z",
    transform: "translate(-381.95 -14.862)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_111",
    "data-name": "Caminho 111",
    d: "M608.828,234.316l-2.545.306-.4-2.409,2.465-.567Z",
    transform: "translate(-552.984 -211.423)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M544.03,519.677l-2.249-1.178,1.11-2.261,2.31,1.063Z",
    transform: "translate(-494.482 -471.169)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M560.546,122.049l-2.146,1.363-1.433-1.989,1.99-1.586Z",
    transform: "translate(-508.343 -109.376)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M472.792,44.045l-2.111-1.29,1.208-2.226,2.317,1.4Z",
    transform: "translate(-429.589 -36.991)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_115",
    "data-name": "Caminho 115",
    d: "M365.526,5.817l-2.436-.429.327-2.52,2.656.488Z",
    transform: "translate(-331.391 -2.618)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_116",
    "data-name": "Caminho 116",
    d: "M449.986,670.282l-2.385-.924,1.2-2.475,2.2,1.211Z",
    transform: "translate(-408.524 -608.661)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_117",
    "data-name": "Caminho 117",
    d: "M479.528,619.106l-2.1-1.409,1.453-2.16,2.1,1.444Z",
    transform: "translate(-435.743 -561.798)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_118",
    "data-name": "Caminho 118",
    d: "M519.4,78.936l-1.82-1.676,1.619-1.948,2,1.83Z",
    transform: "translate(-472.397 -68.736)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_119",
    "data-name": "Caminho 119",
    d: "M569.2,466.025l-2.35-.979.92-2.349,2.387.866Z",
    transform: "translate(-517.36 -422.302)",
    fill: "#212121"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSobreLampada);
export default __webpack_public_path__ + "static/media/Sobre_Lampada.17dd2c2050cf065187b677f52b10d25e.svg";
export { ForwardRef as ReactComponent };